import {
  postData,
} from 'src/services/RestApi';

/**
 * TMS
 */
export const apiTmsUpdate = async (values) => {
  const queryData = {};
  queryData.tmsId = values.id;
  queryData.carId = values.carId;

  if (values.checkinBy) queryData.checkinBy = values.checkinBy;
  if (values.checkoutBy) queryData.checkoutBy = values.checkoutBy;
  if (values.checkinKm) queryData.checkinKm = values.checkinKm; 
  if (values.checkoutKm) queryData.checkoutKm = values.checkoutKm;

  return await postData('api/tms/censor-edit', queryData);
};

export const apiSendTms = async (values) => {
  const queryData = {
    tmsId: values.tmsId,
    carId: values.carId,
    checkinBy: 0,
    checkoutBy: 0,
  };
  delete values.tmsId;
  delete values.carId;

  await postData('api/tms/censor-edit', queryData);
  
  values.moduleType = 0;
  return await postData('api/ticket/create', values);
};
// EOF

/**
 * REPAIR
 */
export const apiSendRepair = async (values) => {
  if(values.paymentId > 0){
    await postData('api/payment/delete', {
      moduleType: 0,
      paymentId: values.paymentId,
      sourceId: values.sourceId
    });
  }
  delete values.paymentId;

  values.moduleType = 2;
  return await postData('api/ticket/create', values);
};

export const apiUnsendRepair = async (values) => {
  let result = {};
  if(values.ticketId > 0){
    result = await postData('api/ticket/delete', {
      moduleType: 2,
      ticketId: values.ticketId,
      userId: values.userId
    });
  }

  if(values.paymentId > 0){
    result = await postData('api/payment/delete', {
      moduleType: 0,
      paymentId: values.paymentId,
      sourceId: values.sourceId
    });
  }
  return result;
};
// EOF